import { client } from "./api";


type IPinProps = {
  email: string;
  token: string;
};

type IVerifyProps = {
  email: string;
  code: string;
};

export async function sendPinService({ email, token }: IPinProps) {
  const api = client();
  const response = await api.post(
    "/pins",
    { email, type: "forgot" },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function pinVerifyService({ email, code }: IVerifyProps) {
  const api = client();
  const response = await api.post("/pins/verify", { email, code });
  return response.data;
}
